import IRIRigid from "../../img/info/IRI_Rigid.png";
import "./Information.css";

const IRIRigidPage = () => {
    return (
      <div className="info_container">
        <h1>International Roughness Index (IRI) Modeling for Rigid Pavement</h1>
        <h2>Role of IRI to Rigid Pavement</h2>
        <ul>
            <li>The AASHTO Mechanistic-Empirical Pavement Design Guide (MEPDG) provides cost-effective, sustainable design solutions for concrete pavements.</li>
            <li>Implementation challenges arise due to the time-consuming and computationally expensive structural response calculations in Pavement ME software.</li>
        </ul>
        <figure className="figure">
                <img src={IRIRigid} alt="IRI of Rigid" />
                <figcaption>Figure 1 Mechanistic-Empirical-Based IRI modeling for rigid pavement using Artificial Neural Networks. [1]</figcaption>
        </figure>
            <h2>Proposed Approach</h2>
        <ul>
            <li>Developed a new adaptive sampling technique to create an efficient and informative pavement damage database from Pavement ME simulations.</li>
            <li>Hybrid model integrating ANN predictions of rutting, fatigue damage, and thermal cracking with closed-form relationships linking these indicators to IRI.</li>
        </ul>
            <h2>Key Findings:</h2>
       
        <ul>
                <li>The developed model demonstrated superior accuracy in IRI prediction at both global and local levels.</li>
                <li>The developed modelThe developed model achieved performance matching Pavement ME IRI simulations while being more efficient and adaptable to diverse design considerations.</li>
            </ul>
            <div className="info_ref-block">
                <p>[1] Li, H., Sen, S., and Khazanovich, L. (2024). Artificial Neural Networks for Mechanistic-Empirical Concrete Pavement Design: An Efficient Development Approach. 13th International Conference on Concrete Pavements. Minneapolis, Minnesota, USA.</p>
            </div>
      </div>
    );
  }
  
export default IRIRigidPage;